import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Button, { ButtonWrapper } from 'blocks/Button';
import Row from 'blocks/Row';
import { Text } from 'blocks/Text';
import Modal from 'components/Modal';
import { ModalFC } from 'config/types';
import Paths from 'helper/paths';
import { ModalVerifyEmailProps } from 'pages/signup/signup.interface';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

const ModalVerifyEmail: ModalFC<ModalVerifyEmailProps> = ({ open, onClose, setRedirectLogin }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onVerify = async () => {
    navigate(Paths.Login.index().route);
    // redirect('/login');
    onClose && onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '10px' }}>
          <CheckCircleIcon style={{ color: '#60C08E', fontSize: '60px' }} />
          <Text color="success" bold>
            Successful
          </Text>
        </div>
        <Row>
          <Text>{t('pages.signup.sections.verification.fields.verifyEmail.text')}</Text>
        </Row>
      </div>
      <ButtonWrapper justify="center">
        <Button
          width={60}
          onClick={() => {
            onVerify();
          }}
        >
          {t('pages.signup.sections.verification.fields.verifyEmail.label')}
        </Button>
      </ButtonWrapper>
    </Modal>
  );
};

export default ModalVerifyEmail;
